import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AiCommandDto, AiService } from './ai.service';
import { ToastrService } from 'ngx-toastr';
import { CommonModule } from '@angular/common';

import { AiCommandListComponent } from '../ai-command-list/ai-command-list.component';

@Component({
  selector: 'app-ai',
  standalone: true,
  imports: [CommonModule, AiCommandListComponent],
  templateUrl: './ai.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './ai.component.scss'
})
export class AiComponent implements OnInit {
  commands: AiCommandDto[] = [];

  constructor(
    private aiService: AiService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.loadCommands();
  }

  loadCommands(): void {
    this.aiService.getAiCommands().subscribe({
      next: (data) => {
        this.commands = data;
      },
      error: (err) => {
        this.toastr.error('Failed to load AI commands: ' + err.message);
      }
    });
  }
}
